<template>
  <div class="wrap df jcc aic">
    <div class="box step1" v-closable="{
    handler: 'onClose'
  }" v-if="step == 1">
      <!-- <input v-model="projectName" v-on:input="changedName()" type="text" class="input1" placeholder="Name Your Project"> -->
      <button v-on:click="createNewProject()" class="new-project button-form button-form1" v-bind:class="{'button-form-active': nameChanged}">
        New Project
      </button>
      <p class="or">or</p>
      <p class="title"><!-- <strong>1</strong> of 2<br/> -->Select a Project Template</p>
      <!-- <button v-on:click="goToStep2()" class="button-form button-form1" v-bind:class="{'button-form-active': nameChanged}">
        Save Changes
      </button> -->
      <span class="project-templates df fdc">
        <span class="project-template df fdr f1 jcsb"
              v-on:click="createProjectFromTemplate(template)"
              v-for="(template, key1) in $store.getters.projectTemplates"
              v-bind:key="key1">
          <p>{{ template.name }}</p>
          <p>{{ formattedDate(template.created) }}</p>
        </span>
        <span v-if="$store.getters.projectTemplates.length == 0" class="tac">
          <p>No Templates Saved</p>
        </span>
      </span>
      <p class="cancel" v-on:click="cancel()">Cancel</p>
    </div>
    <div class="box step2" v-closable="{
    handler: 'onClose'
  }" v-else-if="step == 2">
      <p class="title title2"><strong>2</strong> of 2<br/>Project Resources</p>
      <p class="description">Select the resources needed for your website project</p>
      <p class="resource-selection">[Resource selection]</p>
      <!-- <button v-on:click="goToStep2()" class="button-form button-form1" v-bind:class="{'button-form-active': nameChanged}">
        That's Everyone
      </button> -->
      <p class="cancel" v-on:click="goToStep1()">Back</p>
      <p class="skip" v-on:click="createNewProject()">Skip >></p>
    </div>
  </div>
</template>

<script>
export default {
  // import Login from '../components/Login'

  name: 'CreateNewProject',
  data () {
    return {
      step: 1,
      nameChanged: true,
      projectName: 'New Project',
      createdTime: 0
    }
  },
  props: [],
  components: {

  },
  methods: {
    formattedDate (d) {
      var date = new Date(d)
      var dateString = (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear()
      return dateString
    },
    onClose (event) {
      console.log('onclose')
      // event.stopPropagation()
      var d = new Date
      var now = d.getTime()

      if ((now - this.createdTime > 100)) {
        this.$emit('closeNewProject')
      }
    },
    changedName () {
      this.nameChanged = true
    },
    goToStep1 () {
      this.step = 1
    },
    goToStep2 () {
      this.step = 2
    },
    cancel () {
      this.$emit('closeNewProject')
    },
    createNewProject () {
      console.log('create new project', this.$store.getters.companyCost)
      this.$store.dispatch('createNewProject', {
        name: this.projectName,
        myID: this.$store.getters.uid,
        rate: this.$store.getters.companyRate,
        cost: this.$store.getters.userData.companyCost,
        contingency: this.$store.getters.companyContingency,
        companyTasks: this.$store.getters.companyTasks
      }).then(() => {
        console.log('after creating new project')
        // close new project window
        this.$emit('closeNewProject')
      })
    },
    createProjectFromTemplate (template) {
      console.log('create from template', template)
      var data = {
        fromTemplate: true,
        myID: this.$store.getters.uid,
        template: template,
        name: 'New Project'
      }
      this.$store.dispatch('createNewProject', data).then(() => {
        console.log('after creating new project')
        // close new project window
        this.$emit('closeNewProject')
      })
    }
  },
  computed: {

  },
  created () {
    var d = new Date
    this.createdTime = d.getTime()
    document.onkeydown = checkKey;
    var _this = this
    function checkKey(e) {
      console.log('enter', e.keyCode == '13')
        e = e || window.event;
        if (e.keyCode == '13') {
        console.log('enter2')
            e.preventDefault()
            _this.createNewProject()
        }
    }
  }
}
</script>

<style scoped lang="scss">
.wrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 11;
}
.box {
  position: absolute;
  width: 700px;
  // margin-bottom: 200px;
    top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  padding: 50px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -moz-flex-direction: column;
  -ms-flex-direction: column;
  -o-flex-direction: column;
  flex-direction: column;
  justify-content: center;
  -ms-align-items: center;
  align-items: center;
  z-index: 2;

  // Responsive Style
  // @media max-width: 768px
  @media(max-width: 768px) {
    width: calc(100% - 40px);
    padding-left: 20px;
    padding-right: 20px;
  }
}
.title {
  color: #000000;
  font-size: 24px;
  font-weight: 300;
  letter-spacing: 1.29px;
  line-height: 43px;
  text-align: center;
  margin-bottom: 40px;

  // Responsive Style
  // @media max-width: 768px
  @media(max-width: 768px) {
    font-size: 18px;
    margin-bottom: 10px;
  }
}
.title2 {
  margin-bottom: 0px;
}
.input1, .button-form1 {
  width: 420px;
}
.input1 {
  margin-bottom: 40px;
}
.cancel, .skip {
  position: absolute;
  color: #5558FF;
  font-size: 12px;
  font-weight: bold;
  line-height: 14px;
  text-transform: uppercase;
}
.cancel {
  left: 20px;
  top: 20px;
}
.skip {
  right: 20px;
  top: 20px;
}
.description {
  color: #000000;
  font-size: 16px;
  line-height: 21px;
  text-align: center;
}
.resource-selection {
  height: 200px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  justify-content: center;
  -ms-align-items: center;
  align-items: center;
}
.or {
  margin-bottom: 10px;
}
.new-project {
  margin-bottom: 25px;

  // Responsive Style
  // @media max-width: 768px
  @media(max-width: 768px) {
    width: auto;
    padding-top: 16px;
    padding-bottom: 16px;
    min-width: 280px;
  }
}
.project-templates {
  width: 420px;
  max-height: 300px;
  overflow: auto;

  // Responsive Style
  // @media max-width: 768px
  @media(max-width: 768px) {
    width: 280px;
  }
}
.project-template {
  margin-bottom: 10px;
  cursor: pointer;

  & > p {
    cursor: pointer;
  }

  & > p:first-child {
    font-size: 18px;
    font-weight: 500;
  }

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
